var map = {
	"./ClaudeAICourse.png": 58816,
	"./JavaCourseLogo.png": 73369,
	"./JavaScriptCourseLogo.png": 98396,
	"./JavaScriptCourseLogo2.png": 13236,
	"./PythonCourseLogo.png": 72847,
	"./PythonCourseLogo2.png": 97933,
	"./github.svg": 25614,
	"./google.svg": 65282,
	"./java-logo.png": 62431,
	"./javascript-logo.png": 36032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83927;